import { QueryClient } from '@tanstack/react-query';

// Create a single instance for the entire lifecycle
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,                       // falhou uma vez, tenta de novo
            staleTime: 1000 * 30,           // 30s: dado considerado fresco
            gcTime: 1000 * 60 * 5,          // 5min: substitui o antigo cacheTime
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            refetchOnMount: true,          // busca novamente ao montar quando o dado estiver stale
            networkMode: 'online',
        },
        mutations: {
            retry: 0,
            networkMode: 'online',
        },
    },
});

export default queryClient;
